export default __webpack_public_path__ + "static/media/oval_b.dc80873a.svg";